import React, { createContext, useContext, useState, ReactNode } from 'react';

interface InsuranceForDoctorsFormTypeContextProps {
  formType: 'basic-flow-form' | 'coverage-details-form' | 'more-offers-form';
  formInfo: {
    firstName?: string | null;
    lastName?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    mobileNumber?: string | null;
    affilatedAssociation?: string | null;
    emailId?: string | null;

    selectedSpeciality?: string | null; //indemnity

    vehicleCoverType?: string | null; //motor
    policyExpiryDate?: Date | null; //motor

    numberOfBedsRange?: string | null; //medical setup

    insuranceType?: string | null; //health
    sumInsuredRange?: string | null; //health + home + cyber

    propertyType?: string | null; //Home

    professionalIndemnityForDoctors?: boolean | null;
    professionalIndemnityForMedicalSetup?: boolean | null;
    motorInsurance?: boolean | null;
    healthInsurance?: boolean | null;
    homeInsurance?: boolean | null;
    cyberInsurance?: boolean | null;
    otherInsurance?: boolean | null;

    numberOfBeds?: number | null;
    vehicleRegistrationNumber?: string | null; //motor + others

    typeOfHealth?: boolean | null;
    sumInsured?: number | null;

    pincode?: number | null; //home + others
    homeInsuranceSumInsured?: number | null;

    cyberInsuranceSumInsured?: number | null;

    typeOfOtherInsurance?: string | null;

    leadId?: number;
  };
  setBasicFlowForm: () => void;
  setCoverageDetailsForm: () => void;
  setMoreOffersForm: () => void;

  setFormInfo: (info: {
    firstName?: string | null;
    lastName?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    mobileNumber?: string | null;
    affilatedAssociation?: string | null;
    emailId?: string | null;

    selectedSpeciality?: string | null;

    vehicleCoverType?: string | null;
    policyExpiryDate?: Date | null;

    numberOfBedsRange?: string | null;

    insuranceType?: string | null;
    sumInsuredRange?: string | null;

    propertyType?: string | null;

    professionalIndemnityForDoctors?: boolean | null;
    professionalIndemnityForMedicalSetup?: boolean | null;
    motorInsurance?: boolean | null;
    healthInsurance?: boolean | null;
    homeInsurance?: boolean | null;
    cyberInsurance?: boolean | null;
    otherInsurance?: boolean | null;

    numberOfBeds?: number | null;
    vehicleRegistrationNumber?: string | null;

    typeOfHealth?: boolean | null;
    sumInsured?: number | null;

    pincode?: number | null;
    homeInsuranceSumInsured?: number | null;

    cyberInsuranceSumInsured?: number | null;

    typeOfOtherInsurance?: string | null;

    leadId?: number;
  }) => void;
}

export const InsuranceForDoctorsFormTypeContext = createContext<InsuranceForDoctorsFormTypeContextProps | undefined>(
  undefined,
);

interface FormTypeProviderProps {
  children: ReactNode;
}

export const InsuranceForDoctorsFormTypeProvider: React.FC<FormTypeProviderProps> = ({ children }) => {
  const [formType, setFormType] = useState<'basic-flow-form' | 'coverage-details-form' | 'more-offers-form'>(
    'basic-flow-form',
  );
  const [formInfo, setFormInfo] = useState<{
    firstName?: string | null;
    lastName?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    mobileNumber?: string | null;
    affilatedAssociation?: string | null;
    emailId?: string | null;

    selectedSpeciality?: string | null;

    vehicleCoverType?: string | null;
    policyExpiryDate?: Date | null;

    numberOfBedsRange?: string | null;

    insuranceType?: string | null;
    sumInsuredRange?: string | null;

    propertyType?: string | null;

    professionalIndemnityForDoctors?: boolean | null;
    professionalIndemnityForMedicalSetup?: boolean | null;
    motorInsurance?: boolean | null;
    healthInsurance?: boolean | null;
    homeInsurance?: boolean | null;
    cyberInsurance?: boolean | null;
    otherInsurance?: boolean | null;

    numberOfBeds?: number | null;
    vehicleRegistrationNumber?: string | null;

    typeOfHealth?: boolean | null;
    sumInsured?: number | null;

    pincode?: number | null;
    homeInsuranceSumInsured?: number | null;

    cyberInsuranceSumInsured?: number | null;

    typeOfOtherInsurance?: string | null;

    leadId?: number;
  }>({
    firstName: null,
    lastName: null,
    gender: null,
    dateOfBirth: null,
    mobileNumber: null,
    affilatedAssociation: null,
    emailId: null,

    selectedSpeciality: null,

    vehicleCoverType: null,
    policyExpiryDate: null,

    numberOfBedsRange: null,

    insuranceType: null,
    sumInsuredRange: null,

    propertyType: null,

    professionalIndemnityForDoctors: null,
    professionalIndemnityForMedicalSetup: null,
    motorInsurance: null,
    healthInsurance: null,
    homeInsurance: null,
    cyberInsurance: null,
    otherInsurance: null,

    numberOfBeds: null,
    vehicleRegistrationNumber: null,

    typeOfHealth: null,
    sumInsured: null,

    pincode: null,
    homeInsuranceSumInsured: null,

    cyberInsuranceSumInsured: null,

    typeOfOtherInsurance: null,

    leadId: 0, //TODO
  });

  const setBasicFlowForm = () => setFormType('basic-flow-form');
  const setCoverageDetailsForm = () => setFormType('coverage-details-form');
  const setMoreOffersForm = () => setFormType('more-offers-form');

  const setFormInfoValues = (info: {
    firstName?: string | null;
    lastName?: string | null;
    gender?: string | null;
    dateOfBirth?: Date | null;
    mobileNumber?: string | null;
    affilatedAssociation?: string | null;
    emailId?: string | null;

    selectedSpeciality?: string | null;

    vehicleCoverType?: string | null;
    policyExpiryDate?: Date | null;

    numberOfBedsRange?: string | null;

    insuranceType?: string | null;
    sumInsuredRange?: string | null;

    propertyType?: string | null;

    professionalIndemnityForDoctors?: boolean | null;
    professionalIndemnityForMedicalSetup?: boolean | null;
    motorInsurance?: boolean | null;
    healthInsurance?: boolean | null;
    homeInsurance?: boolean | null;
    cyberInsurance?: boolean | null;
    otherInsurance?: boolean | null;

    numberOfBeds?: number | null;
    vehicleRegistrationNumber?: string | null;

    typeOfHealth?: boolean | null;
    sumInsured?: number | null;

    pincode?: number | null;
    homeInsuranceSumInsured?: number | null;

    cyberInsuranceSumInsured?: number | null;

    typeOfOtherInsurance?: string | null;
    leadId?: number;
  }) => setFormInfo((prevInfo) => ({ ...prevInfo, ...info }));

  return (
    <InsuranceForDoctorsFormTypeContext.Provider
      value={{
        formType,
        formInfo,
        setBasicFlowForm,
        setCoverageDetailsForm,
        setMoreOffersForm,
        setFormInfo: setFormInfoValues,
      }}
    >
      {children}
    </InsuranceForDoctorsFormTypeContext.Provider>
  );
};

export const useInsuranceForDoctorsFormType = (): InsuranceForDoctorsFormTypeContextProps => {
  const context = useContext(InsuranceForDoctorsFormTypeContext);
  if (!context) {
    throw new Error('useInsuranceForDoctorsFormType must be used within an InsuranceForDoctorsFormTypeProvider');
  }
  return context;
};
